import { type ListNotificationsQuery } from '@repo/api-client';

/** Query keys for what the reader has been told. */
export const notificationKeys = {
  all: ['notifications'] as const,
  list: (query: ListNotificationsQuery) =>
    [...notificationKeys.all, 'list', query] as const,
  unread: () => [...notificationKeys.all, 'unread'] as const,
  preferences: () => [...notificationKeys.all, 'preferences'] as const,
};
